'use strict';

import React, { Component } from 'react';
var  $ = require('jquery');


class ProfileAboutItemHouse extends Component{
    state = {
            //Initiate Time for the chart
            HouseInfoStatus: 'pmb-block',
            MenuHouseInfoStatus: 'dropdown',
            area: this.props.area,
            nbocupency: this.props.nbocupency,
            appartmentStatus: this.props.AppartmentStatus ,
            appartmentType: this.props.AppartmentType ,
            dateOfBuilding: this.props.dateOfBuilding,
            postcode: this.props.postcode,
            city: this.props.city,
            country: this.props.country
        }
    showMenuHouseInfo= (e) => {
        e.preventDefault();
        if (this.state.MenuHouseInfoStatus === 'dropdown open') {
            this.setState({MenuHouseInfoStatus: 'dropdown'});
        } else {
            this.setState({MenuHouseInfoStatus: 'dropdown open'});
        }
    }
    showEditMenuHouseInfo= (e) => {
        e.preventDefault();
        this.setState({MenuHouseInfoStatus: 'dropdown', HouseInfoStatus: 'pmb-block toggled'});
    }
    closeHouseInfo= (e) => {
        e.preventDefault();
        this.setState({MenuHouseInfoStatus: 'dropdown', HouseInfoStatus: 'pmb-block'});
    }
    saveHouseInfo= (e) => {
        var methodName = "saveHouseInfo";
        e.preventDefault();
        //Collect Information And Send this information update to BackEnd
        console.log("Area value -- > " + this.state.area);
        //Replace information
        //Récupéraiton des données de la box
        var urlBox = "/user/change/housing?area=" + this.state.area + "&nbocupency=" + this.state.nbocupency + "&appartmentStatus=" + this.state.appartmentStatus + "&appartmentType=" + this.state.appartmentType + "&dateOfBuilding=" + this.state.dateOfBuilding + "&country=" + this.state.country + "&city=" + this.state.city + "&postcode=" + this.state.postcode;

        this.serverRequestBox = $.get(urlBox, function(result) {

            console.log('[INFO],' + methodName + ',  reception front des données box ');
            console.log(result);

            try {
                if (result.error === 'OK') {
                    this.setState({MenuHouseInfoStatus: 'dropdown', HouseInfoStatus: 'pmb-block'});
                    this.props.reloadInfo();
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

        }.bind(this));
    }
    handleAreaChange= (e) => {
        e.preventDefault();
        this.setState({area: e.target.value});
    }
    handleOcupencyChange= (e) => {
        e.preventDefault();
        this.setState({nbocupency: e.target.value});
    }
    handleAppartmentStatusChange= (e) => {
        e.preventDefault();
        this.setState({appartmentStatus: e.target.value});
    }
    handleDateOfBuildingChange= (e) => {
        e.preventDefault();

        this.setState({dateOfBuilding: e.target.value});
    }
    handleAppartmentTypeChange= (e) => {
        e.preventDefault();

        this.setState({appartmentType: e.target.value});
    }
    cityChange= (e) => {
        e.preventDefault();
        this.setState({city: e.target.value});
    }
    postcodeChange= (e) => {
        e.preventDefault();
        this.setState({postcode: e.target.value})
    }
    countryChange= (e) => {
        e.preventDefault();
        this.setState({country: e.target.value});
    }
    componentWillUnmount= () => {
      try{
        this.serverRequestBox.abort();
      }catch(e){
        console.log(e);
      }
    }
    render() {

        return (
            <div className={this.state.HouseInfoStatus}>
                <div className="pmbb-header">
                    <h2>
                        <i className="zmdi zmdi-home m-r-5"></i>Information sur le logement</h2>

                    <ul className="actions">
                        <li className={this.state.MenuHouseInfoStatus}>
                            <a href="#" data-toggle="dropdown" onClick={this.showMenuHouseInfo}>
                                <i className="zmdi zmdi-more-vert"></i>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a data-pmb-action="edit" href="#" onClick={this.showEditMenuHouseInfo}>Edit</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className="pmbb-body p-l-30">
                    <div className="pmbb-view">
                        <dl className="dl-horizontal">
                            <dt>Type du bien</dt>
                            <dd>{this.props.AppartmentType}</dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt>Type de résidence</dt>
                            <dd>{this.props.AppartmentStatus}</dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt>Surface du logement</dt>
                            <dd>{this.props.area}
                                m2</dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt>Année de construction</dt>
                            <dd>{this.props.dateOfBuilding}</dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt>Nombre d'occupants</dt>
                            <dd>{this.props.nbocupency}</dd>
                        </dl>
                    </div>

                    <div className="pmbb-edit">
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Type du bien</dt>
                            <dd>
                                <div className="fg-line">
                                    <select className="form-control" defaultValue={this.props.appartmentType} onChange={this.handleAppartmentTypeChange}>
                                        <option value='' ></option>
                                        <option value='Appartement' >Appartement</option>
                                        <option value='Maison'>Maison</option>
                                        <option value='Autre'>Autre</option>
                                    </select>
                                </div>

                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Type de résidence</dt>
                            <dd>
                                <div className="fg-line">
                                    <select className="form-control" defaultValue={this.props.appartmentStatus}  onChange={this.handleAppartmentStatusChange}>
                                        <option value='' ></option>
                                        <option value='Principale' >Principale</option>
                                        <option value='Secondaire'>Secondaire</option>
                                        <option value='Autre'>Autre</option>
                                    </select>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Surface du logement</dt>
                            <dd>
                                <div className="dtp-container dropdown fg-line">
                                    <input type='number' className="form-control" data-toggle="dropdown" placeholder={this.props.area} value={this.state.area} onChange={this.handleAreaChange}/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Année de construction</dt>
                            <dd>
                                <div className="dtp-container dropdown fg-line">
                                    <input type="text" className="form-control input-mask" placeholder={this.props.dateOfBuilding} value={this.state.dateOfBuilding} onChange={this.handleDateOfBuildingChange}/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Nombre d'occupants</dt>
                            <dd>
                                <div className="dtp-container dropdown fg-line">
                                    <input type='number' className="form-control" data-toggle="dropdown" placeholder={this.props.nbocupency} value={this.state.nbocupency} onChange={this.handleOcupencyChange}/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Code postal</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="text" className="form-control" placeholder={this.props.postcode} value={this.state.postcode} onChange={this.postcodeChange}/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Ville</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="text" className="form-control" placeholder={this.props.city} value={this.state.city} onChange={this.cityChange}/>
                                </div>
                            </dd>
                        </dl>
                        <dl className="dl-horizontal">
                            <dt className="p-t-10">Pays</dt>
                            <dd>
                                <div className="fg-line">
                                    <input type="text" className="form-control" placeholder={this.props.country} value={this.state.country} onChange={this.countryChange}/>
                                </div>
                            </dd>
                        </dl>

                        <div className="m-t-30">
                            <button className="btn btn-primary btn-sm" onClick={this.saveHouseInfo}>Save</button>
                            <button data-pmb-action="reset" className="btn btn-link btn-sm" onClick={this.closeHouseInfo}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
};
export default ProfileAboutItemHouse
